import React from 'react';
import { Button, Column } from '@codeparva/ui-components-library';
import { Link } from 'gatsby';
import TopBarSocialMediaIcons from './TopBarSocialMediaIcons';
import { TopBarTypes } from './topBarTypes';
import {
  TopBarFacilityDetailsVariantTwo,
  TopBarFacilityDetailsVariantOne,
  renderPayRentButton,
  TopBarFacilityDetailsVariantThree,
  TopBarFacilityDetailsVariantFour,
} from './TopBarFacilityDetails';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { useThemeContext } from './hooks/themeContext';
import { HEADER_ICON_SIZES } from '../Header/constants';
import { GenericFacilityDetailsHelper } from './helpers/genericFacilityDetailsHelper';
import { useWindowDimensions } from '../../../../utilities/Dimensions';
import { desktopscreensize } from '../../../../utilities/constants';

export const renderTopBarVariant1 = ({
  iconsList,
  contactDetails,
  redirectDetails,
  contactDetailsforIcons,
  buttonsConfig,
}: TopBarTypes.TTopBarVariantDataType) => {
  const currTheme = useThemeContext();
  const { width } = useWindowDimensions();
  const { show, showOnTouchDevice, url } = buttonsConfig;
  const ButtonClass = () => {
    return (
      <Button
        className={`buttonDisplayVariant1 cp-primary-button-${
          currTheme === 'light' ? 'light' : 'dark'
        }`}
      >
        {buttonsConfig.text} &nbsp;
        <FontAwesomeIcon
          iconClassName={buttonsConfig.iconName}
          iconContextProps={{
            className: `payRentIcon`,
            style: {
              fontSize: HEADER_ICON_SIZES.facilityDetailsiconSize,
            },
          }}
        />
      </Button>
    );
  };
  const ButtonComponent = () => {
    if (show && showOnTouchDevice) {
      return <ButtonClass />;
    } else if (show && !showOnTouchDevice) {
      return <ButtonClass />;
    } else if (!show && showOnTouchDevice && width < desktopscreensize) {
      return <ButtonClass />;
    } else {
      return <></>;
    }
  };
  return (
    <>
      {TopBarFacilityDetailsVariantOne(
        contactDetails,
        redirectDetails,
        iconsList
      )}
      <Column className="topbarColVariant px-0">
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.facilityDetails}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="address"
          variantType="topbar-1"
        />
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.emailID}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="email"
          variantType="topbar-1"
        />
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.phoneNumber}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="phone"
          variantType="topbar-1"
        />
      </Column>

      <TopBarSocialMediaIcons {...contactDetailsforIcons}>
        <Link to={url} className={`payRentButton`}>
          <ButtonComponent />
        </Link>
      </TopBarSocialMediaIcons>
    </>
  );
};

export const renderTopBarVariant2 = ({
  iconsList,
  contactDetails,
  redirectDetails,
  contactDetailsforIcons,
  locationtype,
  buttonsConfig,
  variant,
}: TopBarTypes.TTopBarVariantDataType) => {
  return (
    <>
      {TopBarFacilityDetailsVariantTwo(
        contactDetails,
        redirectDetails,
        iconsList
      )}
      <Column
        renderAs="div"
        className="topbarColVariant is-9-widescreen is-9-desktop is-7-tablet px-0"
      >
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.facilityDetails}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="address"
          variantType="topbar-2"
        />
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.emailID}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="email"
          variantType="topbar-2"
        />
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.mailingAddress}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="mailingAddress"
          variantType="topbar-2"
        />
      </Column>
      <TopBarSocialMediaIcons {...contactDetailsforIcons} />
      <Column
        renderAs="div"
        className="topbarColVariantPayRentAndFacilityDetailColumn is-3-desktop is-5-tablet"
      >
        {renderPayRentButton(locationtype, buttonsConfig, variant)}
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.phoneNumber}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="phone"
          variantType="topbar-2"
        />
      </Column>
    </>
  );
};

export const renderTopBarVariant3 = ({
  iconsList,
  contactDetails,
  redirectDetails,
  contactDetailsforIcons,
  locationtype,
  buttonsConfig,
  variant,
}: TopBarTypes.TTopBarVariantDataType) => {
  return (
    <>
      {TopBarFacilityDetailsVariantThree(
        contactDetails,
        redirectDetails,
        iconsList,
        locationtype,
        buttonsConfig,
        variant
      )}
      <Column renderAs="div" className="topbarColVariant3">
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.facilityDetails}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="address"
          variantType="topbar-3"
        />
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.emailID}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="email"
          variantType="topbar-3"
        />
      </Column>
      <TopBarSocialMediaIcons {...contactDetailsforIcons} />
      <Column renderAs="div" className="topbarColContact">
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.phoneNumber}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="phone"
          variantType="topbar-3"
        />
        {renderPayRentButton(locationtype, buttonsConfig, variant)}
      </Column>
    </>
  );
};

export const renderTopBarVariant4 = ({
  iconsList,
  contactDetails,
  redirectDetails,
  contactDetailsforIcons,
  ctaText,
}: TopBarTypes.TTopBarVariantDataType) => {
  return (
    <>
      <TopBarFacilityDetailsVariantFour
        contactDetails={contactDetails}
        redirectDetails={redirectDetails}
        iconsList={iconsList}
      />
      <Column renderAs="div" className="topbarColVariantFour is-8">
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.facilityDetails}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="address"
          variantType="topbar-4"
        />
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.emailID}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="email"
          variantType="topbar-4"
        />
        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.mailingAddress}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="mailingAddress"
          variantType="topbar-4"
        />
      </Column>
      <TopBarSocialMediaIcons {...contactDetailsforIcons} />
      <Column
        renderAs="div"
        className="topbarColVariant4Desktop ctaText is-4 is-flex is-flex-wrap-nowrap"
      >
        <span className={`ctaText has-text-primary pr-2`}>{ctaText}</span>

        <GenericFacilityDetailsHelper
          contactDetailsInfo={contactDetails.phoneNumber}
          contactDetails={contactDetails}
          iconsList={iconsList}
          redirectDetails={redirectDetails}
          contactDetailsType="phone"
          variantType="topbar-4"
        />
      </Column>
    </>
  );
};
